import { createFileRoute, notFound } from "@tanstack/react-router";

import { usersQueries } from "@/api/resources/users/queries";
import { workspacesQueries } from "@/api/resources/workspaces/queries";
import UserPageWorkspace from "@/components/User/UserPageWorkspace";
import i18n from "@/providers/i18n";
import { userName } from "@/utils/format";
import Icon from "@/utils/icons";

import type { BreadcrumbsContext } from "@/providers/routerConfig";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/settings/users/$user_id/")({
  beforeLoad: () => {
    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: i18n.t("navigation.workspace"),
        icon: <Icon.WORKSPACE />,
        path: "/workspaces/$workspace_id",
      },
      {
        label: i18n.t("navigation.workspace-users"),
        icon: <Icon.USERS />,
        path: "/workspaces/$workspace_id/settings/users",
      },
    ];
    return { breadcrumbs };
  },
  loader: async ({ context, params: { workspace_id, user_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();

    const currentUser = await context.queryClient.ensureQueryData(usersQueries.byId(user_id));
    if (!currentUser) throw notFound();

    const breadcrumbs: BreadcrumbsContext[] = [{ label: userName(currentUser) ?? "", icon: <Icon.USER /> }];
    context.breadcrumbs.splice(2, 1, ...breadcrumbs);

    return currentUser;
  },
  component: UserPageWorkspace,
});
